var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_716_2455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 3.3867C10.7067 3.68003 12.32 5.29337 12.6134 7.33337H14.6334C14.32 4.1867 11.8134 1.68003 8.66671 1.3667V3.3867ZM12.6134 8.6667C12.32 10.7067 10.7067 12.32 8.66671 12.6134V14.6334C11.8134 14.32 14.32 11.8134 14.6334 8.6667H12.6134ZM7.33337 12.6134C5.07337 12.2867 3.33337 10.3467 3.33337 8.00003C3.33337 5.65337 5.07337 3.71337 7.33337 3.3867V1.3667C3.96671 1.70003 1.33337 4.54003 1.33337 8.00003C1.33337 11.46 3.96671 14.3 7.33337 14.6334V12.6134Z",
    fill: "#7C7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_2455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDonut);
export default __webpack_public_path__ + "static/media/icon-donut.e908cd6221fd429ce46dc0069a713d4b.svg";
export { ForwardRef as ReactComponent };